<template>
  <div
    data-component-group="labels-form"
    data-component="edit"
    class="elevation-1"
  >
    <LabelForm
      :label="label"
      confirm-trigger-label="Update label"
      :is-disabled="!canEditDetails"
      :is-loading="isLoading"
      :on-submit="onSubmit"
    >
      <template v-slot:beforeForm>
        <layout-section-header
          title="Details"
          :has-trigger="hasTrigger"
          :trigger-label="triggerLabel"
          @toggle="toggleEditDetails"
        />
      </template>
    </LabelForm>
  </div>
</template>

<script lang="ts">
  import { defineComponent, type PropType } from 'vue';
  import LabelForm from './AddNew.vue';
  import { isObj } from '../../../utils';
  import type { LabelListItem } from '@/types';

  export default defineComponent({
    components: {
      LabelForm,
    },
    props: {
      label: {
        type: Object as PropType<Partial<LabelListItem>>,
        required: true,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      onCancel: {
        type: Function as PropType<(...args: any[]) => any>,
        default: undefined,
      },
      onSubmit: {
        type: Function as PropType<(...args: any[]) => any>,
        default: undefined,
      },
    },
    data() {
      return {
        canEditDetails: false,
      };
    },
    computed: {
      triggerLabel() {
        return !this.canEditDetails ? 'Edit details' : 'Close';
      },
      hasTrigger() {
        return this.$store.getters['auth/isAuthorized']([{ subject: 'label', actions: ['update'] }]);
      },
    },
    watch: {
      label(nextLabel: Partial<LabelListItem>) {
        if (isObj(nextLabel)) {
          this.canEditDetails = false;
        }
      },
    },
    methods: {
      toggleEditDetails() {
        this.canEditDetails = !this.canEditDetails;
      },
    },
  });
</script>
